import React from "react";

const FooterPinterestIcon = (): JSX.Element => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 319.81 319.81"
  >
    <defs>
      <clipPath id="clip-path-4a" transform="translate(-146.1 -138.84)">
        <path
          className="cls-1 a"
          fill="none" clipRule="evenodd" d="M160.63,298.74A145.23,145.23,0,1,1,263,437.63c5.93-9.65,14.78-25.48,18.07-38.12,1.77-6.8,9.05-34.55,9.05-34.55,4.74,9,18.59,16.69,33.32,16.69,43.84,0,75.43-40.31,75.43-90.42,0-48-39.19-84-89.62-84-62.72,0-96,42.11-96,88,0,21.33,11.35,47.87,29.51,56.32,2.75,1.28,4.23.71,4.85-1.95.48-2,2.94-11.89,4-16.49a4.34,4.34,0,0,0-1-4.15c-6-7.29-10.83-20.69-10.83-33.18,0-32.06,24.28-63.09,65.65-63.09,35.7,0,60.72,24.34,60.72,59.14,0,39.32-19.86,66.56-45.7,66.56-14.26,0-25-11.79-21.53-26.26,4.1-17.27,12.05-35.92,12.05-48.4,0-11.16-6-20.48-18.41-20.48-14.58,0-26.29,15.09-26.29,35.31a52.5,52.5,0,0,0,4.34,21.57s-14.4,60.93-17,72.27c-2.92,12.55-1.77,30.25-.49,41.74A145.45,145.45,0,0,1,160.63,298.74Z"
        />
      </clipPath>
      <clipPath id="clip-path-4b" transform="translate(-146.1 -138.84)">
        <rect className="cls-2" fill="none" x="160.63" y="153.38" width="290.74" height="290.74" />
      </clipPath>
    </defs>
    <g className="cls-3" clip-path="url(#clip-path-4a)">
      <g className="cls-4">
        <g className="cls-5" clip-path="url(#clip-path-4a)">
          <g className="cls-5" clip-path="url(#clip-path-4b)">
            <rect width="319.81" height="319.81" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FooterPinterestIcon;
